import type { MaybeRefOrGetter } from 'vue'

/**
 * Bettet ein JSON-LD-Objekt als `<script type="application/ld+json">` in den
 * Head der aktuellen Seite ein.
 */
export function useJsonLd(data: MaybeRefOrGetter<Record<string, unknown> | null | undefined>, key?: string) {
  useHead({
    script: [{
      key,
      type: 'application/ld+json',
      innerHTML: () => {
        const value = toValue(data)
        return value ? JSON.stringify({ '@context': 'https://schema.org', ...value }) : ''
      }
    }]
  })
}
